import React, { useRef } from 'react';
import { useClickOutsideEffect } from './hooks';

const Popover = ({ title = "Title", children = null, onClickOutside = () => null, offset = {} }) => {
  const popover = useRef(null);

  useClickOutsideEffect(popover, onClickOutside);

  return (
    <div
      className="popover"
      ref={popover}
      style={{
        marginTop: `${offset?.top ?? 0}px`,
        marginLeft: `${offset?.left ?? 0}px`
      }}
    >
      <div className="popover-header">
        <h4>{title}</h4>
      </div>
      <hr className="divider" />
      { children}
    </div>
  );
};

export default Popover;
